<div class="dashboard-container mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <!-- Loading / Error -->
  <div *ngIf="isDashboardLoading" class="text-muted mb-3">Loading dashboard...</div>
  <div *ngIf="dashboardError || !isDashboardLoading && !dashboardError && dashboardCards.length === 0"
    class="text-muted">
    Dashboard Stats are not found!
  </div>

  <!-- Summary cards driven by computed array -->
  <div class="summary-card-grid" *ngIf="dashboardCards.length > 0">
    <div class="summary-card" *ngFor="let card of dashboardCards"
      (click)="card.route ? navigateTo(card.route, card.value, card.queryParams) : null"
      [style.cursor]="card.route ? 'pointer' : 'default'">
      <div class="card-count">
        <ng-container *ngIf="!card.isMoney; else moneyFmt">
          {{ (card.value) | number:'1.0-0' }}
        </ng-container>
        <ng-template #moneyFmt>
          LKR {{ (card.value) | number:'1.2-2' }}
        </ng-template>
      </div>
      <div class="card-label">{{ card.label }}</div>
      <div class="chart-placeholder"></div>
    </div>
  </div>

  <div class="container-fluid mt-2">
    <div class="row g-4">

      <!-- Chart 1 -->
      <div class="col-12 col-lg-6">
        <app-client-onboarding-chart></app-client-onboarding-chart>
      </div>

      <!-- Chart 2 -->
      <div class="col-12 col-lg-6">
        <app-weekly-wage-withdrawal-chart></app-weekly-wage-withdrawal-chart>
      </div>

    </div>
  </div>


  <!-- Empty-state -->
  <div *ngIf="!isDashboardLoading && !dashboardError && dashboardCards.length === 0" class="text-muted">
    No dashboard data.
  </div>

</div>